<template>
  <div class="template-basicPage">
    <LanuageSelector @selectSpanish="langSpanish" />
    <div class="loginLink">
      <p v-html="$t('registerLogin')"></p>
    </div>
    <div class="container thankyou" v-show="showthankyou">
      <div class="row">
        <div class="col-lg-12">
          <div class="openingParagraph">
            <h2 style="margin-bottom: 30px !important;">{{ $t("thankyouTitle") }}</h2>
          </div>
        </div>
      </div>
      <form>
        <div class="row">
          <div class="col-lg-12 text-center">
            <p v-html="$t('thankyouText')"></p>
          </div>
        </div>
      </form>
    </div>
    <div class="container" v-show="!showthankyou">
      <div class="row">
        <div class="col-lg-12">
          <div class="openingParagraph">
            <h2>{{ $t("openingPara") }}</h2>
          </div>
        </div>
      </div>
      <form @submit.prevent="register">
        <div class="row">
          <div class="col-lg-6">
            <label for="firstName">{{ $t("firstName") }}*</label>
            <input type="text" name="firstName" id="firstName" v-model="user.FirstName" required>
          </div>
          <div class="col-lg-6">
            <label for="lastName">{{ $t("lastName") }}*</label>
            <input type="text" name="lastName" id="lastName" v-model="user.LastName" required>
          </div>
          <div class="col-lg-12">
            <label for="emailAddress">{{ $t("emailAddress") }}*</label>
            <input type="email" name="emailAddress" id="emailAddress" v-model="user.EmailAddress" required>
          </div>
          <div class="col-lg-6">
            <label for="companyName">{{ $t("companyName") }}*</label>
            <input type="text" name="companyName" id="companyName" v-model="user.CompanyName" required>
          </div>
          <div class="col-lg-6">
            <label for="country">{{ $t("country") }}*</label>
            <select name="country" id="country" required v-model="user.Country">
              <option selected disabled>{{ $t("countyDDSelect") }}</option>
              <option value="AF">Afghanistan</option>
              <option value="AX">Aland Islands (Finland)</option>
              <option value="AL">Albania</option>
              <option value="DZ">Algeria</option>
              <option value="AS">American Samoa</option>
              <option value="AD">Andorra</option>
              <option value="AO">Angola</option>
              <option value="AI">Anguilla</option>
              <option value="AQ">Antarctica</option>
              <option value="AG">Antigua &amp; Barbuda</option>
              <option value="AR">Argentina</option>
              <option value="AM">Armenia</option>
              <option value="AW">Aruba</option>
              <option value="AC">Ascension Island</option>
              <option value="AU">Australia</option>
              <option value="AT">Austria</option>
              <option value="AZ">Azerbaijan</option>
              <option value="BS">Bahamas</option>
              <option value="BH">Bahrain</option>
              <option value="BD">Bangladesh</option>
              <option value="BB">Barbados</option>
              <option value="BY">Belarus</option>
              <option value="BE">Belgium</option>
              <option value="BZ">Belize</option>
              <option value="BJ">Benin</option>
              <option value="BM">Bermuda</option>
              <option value="BT">Bhutan</option>
              <option value="BO">Bolivia</option>
              <option value="BA">Bosnia-Herzegovina</option>
              <option value="BW">Botswana</option>
              <option value="BV">Bouvet Island</option>
              <option value="BR">Brazil</option>
              <option value="IO">British Indian Ocean Territory</option>
              <option value="VG">British Virgin Islands</option>
              <option value="BN">Brunei</option>
              <option value="BG">Bulgaria</option>
              <option value="BF">Burkina Faso</option>
              <option value="BI">Burundi</option>
              <option value="KH">Cambodia</option>
              <option value="CM">Cameroon</option>
              <option value="CA">Canada</option>
              <option value="IC">Canary Islands</option>
              <option value="CV">Cape Verde</option>
              <option value="BQ">Caribbean Netherlands</option>
              <option value="KY">Cayman Islands</option>
              <option value="CF">Central African Republic</option>
              <option value="EA">Ceuta &amp; Melilla</option>
              <option value="TD">Chad</option>
              <option value="CL">Chile</option>
              <option value="CN">China</option>
              <option value="CX">Christmas Island</option>
              <option value="CC">Cocos Islands</option>
              <option value="CO">Colombia</option>
              <option value="KM">Comoros</option>
              <option value="CK">Cook Islands</option>
              <option value="CR">Costa Rica</option>
              <option value="HR">Croatia</option>
              <option value="CU">Cuba</option>
              <option value="CW">Curaçao</option>
              <option value="CY">Cyprus</option>
              <option value="CZ">Czech Republic</option>
              <option value="CD">Democratic Republic of the Congo</option>
              <option value="DK">Denmark</option>
              <option value="DG">Diego Garcia</option>
              <option value="DJ">Djibouti</option>
              <option value="DM">Dominica</option>
              <option value="DO">Dominican Republic</option>
              <option value="EC">Ecuador</option>
              <option value="EG">Egypt</option>
              <option value="SV">El Salvador</option>
              <option value="GQ">Equatorial Guinea</option>
              <option value="ER">Eritrea</option>
              <option value="EE">Estonia</option>
              <option value="ET">Ethiopia</option>
              <option value="FK">Falkland Islands</option>
              <option value="FO">Faroe Islands</option>
              <option value="FJ">Fiji</option>
              <option value="FI">Finland</option>
              <option value="FR">France</option>
              <option value="GF">French Guiana</option>
              <option value="PF">French Polynesia</option>
              <option value="TF">French Southern Territories</option>
              <option value="GA">Gabon</option>
              <option value="GM">Gambia</option>
              <option value="GE">Georgia</option>
              <option value="DE">Germany</option>
              <option value="GH">Ghana</option>
              <option value="GI">Gibraltar</option>
              <option value="GR">Greece</option>
              <option value="GL">Greenland</option>
              <option value="GD">Grenada</option>
              <option value="GP">Guadeloupe</option>
              <option value="GU">Guam</option>
              <option value="GT">Guatemala</option>
              <option value="GG">Guernsey</option>
              <option value="GN">Guinea</option>
              <option value="GW">Guinea-Bissau</option>
              <option value="GY">Guyana</option>
              <option value="HT">Haiti</option>
              <option value="HM">Heard &amp; McDonald Islands</option>
              <option value="HN">Honduras</option>
              <option value="HK">Hong Kong</option>
              <option value="HU">Hungary</option>
              <option value="IS">Iceland</option>
              <option value="IN">India</option>
              <option value="ID">Indonesia</option>
              <option value="IR">Iran</option>
              <option value="IQ">Iraq</option>
              <option value="IE">Ireland</option>
              <option value="IM">Isle of Man</option>
              <option value="IL">Israel</option>
              <option value="IT">Italy</option>
              <option value="CI">Ivory Coast</option>
              <option value="JM">Jamaica</option>
              <option value="JP">Japan</option>
              <option value="JE">Jersey</option>
              <option value="JO">Jordan</option>
              <option value="KZ">Kazakhstan</option>
              <option value="KE">Kenya</option>
              <option value="KI">Kiribati</option>
              <option value="XK">Kosovo</option>
              <option value="KW">Kuwait</option>
              <option value="KG">Kyrgyzstan</option>
              <option value="LA">Laos</option>
              <option value="LV">Latvia</option>
              <option value="LB">Lebanon</option>
              <option value="LS">Lesotho</option>
              <option value="LR">Liberia</option>
              <option value="LY">Libya</option>
              <option value="LI">Liechtenstein</option>
              <option value="LT">Lithuania</option>
              <option value="LU">Luxembourg</option>
              <option value="MO">Macau</option>
              <option value="MG">Madagascar</option>
              <option value="MW">Malawi</option>
              <option value="MY">Malaysia</option>
              <option value="MV">Maldives</option>
              <option value="ML">Mali</option>
              <option value="MT">Malta</option>
              <option value="MH">Marshall Islands</option>
              <option value="MQ">Martinique</option>
              <option value="MR">Mauritania</option>
              <option value="MU">Mauritius</option>
              <option value="YT">Mayotte</option>
              <option value="MX">Mexico</option>
              <option value="FM">Micronesia</option>
              <option value="MD">Moldova</option>
              <option value="MC">Monaco</option>
              <option value="MN">Mongolia</option>
              <option value="ME">Montenegro</option>
              <option value="MS">Montserrat</option>
              <option value="MA">Morocco</option>
              <option value="MZ">Mozambique</option>
              <option value="MM">Myanmar</option>
              <option value="NA">Namibia</option>
              <option value="NR">Nauru</option>
              <option value="NP">Nepal</option>
              <option value="NL">Netherlands</option>
              <option value="NC">New Caledonia</option>
              <option value="NZ">New Zealand</option>
              <option value="NI">Nicaragua</option>
              <option value="NE">Niger</option>
              <option value="NG">Nigeria</option>
              <option value="NU">Niue</option>
              <option value="NF">Norfolk Island</option>
              <option value="KP">North Korea</option>
              <option value="MK">North Macedonia</option>
              <option value="MP">Northern Mariana Islands</option>
              <option value="NO">Norway</option>
              <option value="OM">Oman</option>
              <option value="PK">Pakistan</option>
              <option value="PW">Palau</option>
              <option value="PS">Palestine</option>
              <option value="PA">Panama</option>
              <option value="PG">Papua New Guinea</option>
              <option value="PY">Paraguay</option>
              <option value="PE">Peru</option>
              <option value="PH">Philippines</option>
              <option value="PN">Pitcairn Islands</option>
              <option value="PL">Poland</option>
              <option value="PT">Portugal</option>
              <option value="PR">Puerto Rico</option>
              <option value="QA">Qatar</option>
              <option value="CG">Republic of Congo</option>
              <option value="RE">Reunion</option>
              <option value="RO">Romania</option>
              <option value="RU">Russia</option>
              <option value="RW">Rwanda</option>
              <option value="SH">Saint Helena</option>
              <option value="WS">Samoa</option>
              <option value="SM">San Marino</option>
              <option value="ST">Sao Tome e Principe</option>
              <option value="SA">Saudi Arabia</option>
              <option value="SN">Senegal</option>
              <option value="RS">Serbia</option>
              <option value="SC">Seychelles</option>
              <option value="SL">Sierra Leone</option>
              <option value="SG">Singapore</option>
              <option value="SX">Sint Maarten</option>
              <option value="SK">Slovakia (Slovak Republic)</option>
              <option value="SI">Slovenia</option>
              <option value="SB">Solomon Islands</option>
              <option value="SO">Somalia</option>
              <option value="ZA">South Africa</option>
              <option value="GS">South Georgia &amp; South Sandwich Islands</option>
              <option value="KR">South Korea</option>
              <option value="SS">South Sudan</option>
              <option value="ES">Spain</option>
              <option value="LK">Sri Lanka</option>
              <option value="BL">St. Barthélemy</option>
              <option value="KN">St. Kitts &amp; Nevis</option>
              <option value="LC">St. Lucia</option>
              <option value="MF">St. Martin</option>
              <option value="PM">St. Pierre &amp; Miquelon</option>
              <option value="VC">St. Vincent &amp; Grenadines</option>
              <option value="SD">Sudan</option>
              <option value="SR">Suriname</option>
              <option value="SJ">Svalbard and Jan Mayen (Norway)</option>
              <option value="SZ">Swaziland</option>
              <option value="SE">Sweden</option>
              <option value="CH">Switzerland</option>
              <option value="SY">Syria</option>
              <option value="TW">Taiwan</option>
              <option value="TJ">Tajikistan</option>
              <option value="TZ">Tanzania</option>
              <option value="TH">Thailand</option>
              <option value="TL">Timor-Leste</option>
              <option value="TG">Togo</option>
              <option value="TK">Tokelau</option>
              <option value="TO">Tonga</option>
              <option value="TT">Trinidad &amp; Tobago</option>
              <option value="TN">Tunisia</option>
              <option value="TR">Turkey</option>
              <option value="TM">Turkmenistan</option>
              <option value="TC">Turks &amp; Caicos Islands</option>
              <option value="TV">Tuvalu</option>
              <option value="UM">U.S. Outlying Islands</option>
              <option value="VI">U.S. Virgin Islands</option>
              <option value="UG">Uganda</option>
              <option value="UA">Ukraine</option>
              <option value="AE">United Arab Emirates</option>
              <option value="GB">United Kingdom GB</option>
              <option value="US">United States</option>
              <option value="UY">Uruguay</option>
              <option value="UZ">Uzbekistan</option>
              <option value="VU">Vanuatu</option>
              <option value="VA">Vatican City</option>
              <option value="VE">Venezuela</option>
              <option value="VN">Vietnam</option>
              <option value="WF">Wallis &amp; Futuna</option>
              <option value="EH">Western Sahara</option>
              <option value="YE">Yemen</option>
              <option value="ZM">Zambia</option>
              <option value="ZW">Zimbabwe</option>
            </select>
          </div>
          <div class="col-lg-6">
            <label for="contactNumber">{{ $t("contactNumber") }}</label>
            <input type="tel" name="contactNumber" id="contactNumber" v-model="user.ContactNumber">
          </div>
          <div class="col-lg-6">
            <label for="jobTitle">{{ $t("jobTitle") }}</label>
            <input type="text" name="jobTitle" id="jobTitle" v-model="user.JobTitle">
          </div>
          <div class="col-lg-6">
            <label for="FirstName">{{ $t("companyType") }}*</label>
            <select name="companyType" id="companyType" required v-model="user.CompanyType">
              <option selected disabled>{{ $t("companyTypeDDSelect") }}</option>
              <option value="Network TV (Public)">{{ $t("companyTypeDD1") }}</option>
              <option value="Local TV (Public)">{{ $t("companyTypeDD2") }}</option>
              <option value="Network TV (Private)">{{ $t("companyTypeDD3") }}</option>
              <option value="Local TV (Private)">{{ $t("companyTypeDD4") }}</option>
              <option value="OB Truck Companies">{{ $t("companyTypeDD5") }}</option>
              <option value="Production Companies">{{ $t("companyTypeDD6") }}</option>
              <option value="Post Production Companies">{{ $t("companyTypeDD7") }}</option>
              <option value="Equipment Rental Companies">{{ $t("companyTypeDD8") }}</option>
              <option value="Independent User / Freelance">{{ $t("companyTypeDD9") }}</option>
              <option value="Corporate">{{ $t("companyTypeDD10") }}</option>
              <option value="House of Worship / Churches">{{ $t("companyTypeDD11") }}</option>
              <option value="Reseller / Distributor">{{ $t("companyTypeDD12") }}</option>
              <option value="System Integrator">{{ $t("companyTypeDD13") }}</option>
              <option value="Government / Public">{{ $t("companyTypeDD14") }}</option>
              <option value="Security Forces / Police">{{ $t("companyTypeDD15") }}</option>
              <option value="University / College">{{ $t("companyTypeDD16") }}</option>
              <option value="Secondary School">{{ $t("companyTypeDD17") }}</option>
              <option value="Primary School">{{ $t("companyTypeDD18") }}</option>
              <option value="Other Educational Institutes">{{ $t("companyTypeDD19") }}</option>
              <option value="Students">{{ $t("companyTypeDD20") }}</option>
              <option value="Other">{{ $t("companyTypeDD21") }}</option>
            </select>
          </div>
          <div class="col-lg-6">
            <label for="LastName">{{ $t("mainProductionGenre") }}*</label>
            <select name="mainProductionGenre" id="mainProductionGenre" required v-model="user.mainProdcutionGenre">
              <option selected disabled>{{ $t("GenreDDSelect") }}</option>
              <option value="Film & TV: Documentary">{{ $t("GenreDD1") }}</option>
              <option value="Film & TV: Studio/Production">{{ $t("GenreDD2") }}</option>
              <option value="Film & TV: Narrative">{{ $t("GenreDD3") }}</option>
              <option value="Film & TV: Episodic">{{ $t("GenreDD4") }}</option>
              <option value="Film & TV: Sports">{{ $t("GenreDD5") }}</option>
              <option value="Film & TV: News/Journalism">{{ $t("GenreDD6") }}</option>
              <option value="Commercial/Advertising">{{ $t("GenreDD7") }}</option>
              <option value="Corporate Content">{{ $t("GenreDD8") }}</option>
              <option value="Educational Content">{{ $t("GenreDD9") }}</option>
              <option value="Wedding">{{ $t("GenreDD10") }}</option>
              <option value="Music">{{ $t("GenreDD11") }}</option>
              <option value="Gaming / Esports">{{ $t("GenreDD12") }}</option>
              <option value="House of Worship">{{ $t("GenreDD13") }}</option>
              <option value="Internet Content">{{ $t("GenreDD14") }}</option>
              <option value="Surveillance">{{ $t("GenreDD15") }}</option>
              <option value="Monitoring">{{ $t("GenreDD16") }}</option>
              <option value="Others">{{ $t("GenreDD17") }}</option>
            </select>
          </div>
          <div class="col-lg-12">
            <p class="smallText"><span>*</span>{{ $t("mandatoryField") }}</p>
          </div>
          <div class="col-lg-12">
            <label for="">{{ $t("statementSelect") }}*</label>
            <div class="radio">
              <input type="radio" id="select1" name="StatmentSelect" v-model="user.SelectStatment" value="Photography or videography is a hobby I spend a lot of time doing" required>
              <label for="select1">{{ $t("select1") }}</label>
            </div>
            <div class="radio">
              <input type="radio" id="select2" name="StatmentSelect" v-model="user.SelectStatment" value="I am studying for a qualification with a photography or videography focus, such as a degree or diploma" required>
              <label for="select2">{{ $t("select2") }}</label>
            </div>
            <div class="radio">
              <input type="radio" id="select3" name="StatmentSelect" v-model="user.SelectStatment" value="I sometimes take photos or videos for money or reward – but it is not my main source of income" required>
              <label for="select3">{{ $t("select3") }}</label>
            </div>
            <div class="radio">
              <input type="radio" id="select4" name="StatmentSelect" v-model="user.SelectStatment" value="I am a full-time photo or video professional – I take photos or videos professionally on a regular basis for a " required>
              <label for="select4">{{ $t("select4") }}</label>
            </div>
            <div class="radio">
              <input type="radio" id="select5" name="StatmentSelect" v-model="user.SelectStatment" value="I work in the cinema / broadcasting industry as a professional film-maker, camera operator or similar" required>
              <label for="select5">{{ $t("select5") }}</label>
            </div>
            <div class="radio">
              <input type="radio" id="select6" name="StatmentSelect" v-model="user.SelectStatment" value="None of the above" required>
              <label for="select6">{{ $t("select6") }}</label>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="checkbox">
              <input type="checkbox" id="emailMarketting" name="emailMarketting" value="emailMarketting" v-model="user.EmailMarketting">
              <label for="emailMarketting">{{ $t("emailMarketting") }}</label>
              <p>{{ $t("emailUnsubscribe") }}</p>
            </div>
          </div>
          <div class="col-lg-12 mb-60">
            <p style="padding-left: 28px;" v-html="$t('privacyPolicy')" class="mb-0"></p>
          </div>
        </div>
        <div class="actions mb-60">
          <div class="row">
            <div class="col-lg-12">
              <button type="submit" class="Btn">{{ $t("submitButton") }} <i class="arrowRight fas fa-arrow-alt-circle-right"></i></button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import LanuageSelector from '@/snippets/lang/LanuageSelector.vue'
import i18n from '@/plugins/i18n';

export default {
  name: "Home",
  title: "Canon Vision: Register",
  components: {
    LanuageSelector
  },
  data: () => ({
    showthankyou: false,
    user: {
      FirstName: "",
      LastName: "",
      EmailAddress: "",
      CompanyName: "",
      Country: "",
      ContactNumber: "",
      JobTitle: "",
      CompanyType: "",
      mainProdcutionGenre: "",
      SelectStatment: "",
      EmailMarketting: false,
      Language: "en",
    }
  }),
  methods: {
    langSpanish(value){
      let langSpanish = value.target.innerText
      console.log(langSpanish)
      if(langSpanish === 'English'){
        console.log(langSpanish + 'EN')
        i18n.locale = 'en'
        this.user.Language = 'en'
      }
      else if(langSpanish === 'Español'){
        console.log(langSpanish + 'ES')
        i18n.locale = 'es'
        this.user.Language = 'es'
      } else if(langSpanish === 'Français'){
        console.log(langSpanish + 'Fr')
        i18n.locale = 'fr'
        this.user.Language = 'fr'
      } else if(langSpanish === 'Italiano'){
        console.log(langSpanish + 'It')
        i18n.locale = 'it'
        this.user.Language = 'it'
      } else if(langSpanish === 'Deutsch'){
        console.log(langSpanish + 'de')
        i18n.locale = 'de'
        this.user.Language = 'de'
      } else if(langSpanish === 'Pусский'){
        console.log(langSpanish + 'ru')
        i18n.locale = 'ru'
        this.user.Language = 'ru'
      } else{
        console.log('Unknown')
      }
    },
    register(){
      console.log(this.user)
      this.$http({
        method: "post",
        url: "https://canonvision.reydar.com:444/api/Leads/GenerateCustomerLead",
        headers: {
          "content-type": "application/json"
        },
        data: this.user
      })
      .then(data => {
        console.log(data);
        this.$router.push('/')
      })
      .catch(err => console.log(err));
    }
  },
  created() {
    window.location.href = "/";
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/sass/pageTemplates/basicPage.scss";

.loginLink{
  position: absolute;
  top: 90px;
  right: 16.7vw;

  p{
    color: #fff !important;
  }
}

.thankyou{
  margin-bottom: 90px;

  p{
    color: $color4;
    line-height: 32px;
  }
}
</style>

<style lang="scss">
@media (min-width: 768px){
  .template-footer{
    position: fixed;
    bottom: 0;
    width: 100vw;
  }
}
</style>
